var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { bind } from "decko";
import { css, cx } from "emotion";
import { getThemeColorVar } from "../helper/color";
const radioClass = css({
    width: "100%",
    label: {
        cursor: "pointer",
        display: "inline",
        width: "initial",
        fontWeight: 400,
        color: getThemeColorVar("typo", "default"),
        fontSize: "14px",
        lineHeight: "25px",
        marginBottom: "5px",
    },
    input: {
        backgroundColor: getThemeColorVar("background", "default"),
        border: "none",
        color: getThemeColorVar("typo", "default"),
        lineHeight: "20px",
        padding: "9px",
        minWidth: "0px",
        borderRadius: "4px",
        "&:focus": {
            backgroundColor: getThemeColorVar("background", "default"),
            borderColor: getThemeColorVar("background", "lighter"),
            outline: "none",
        },
        "&::placeholder": {
            color: getThemeColorVar("typo", "lighter"),
            fontStyle: "italic",
        },
        "&:disabled": {
            cursor: "not-allowed",
            color: getThemeColorVar("typo", "default"),
        },
        "&:invalid": {
            boxShadow: "none",
        },
        cursor: "pointer",
        display: "inline",
        width: "auto",
        fontWeight: 400,
        marginRight: "5px",
        position: "relative",
        bottom: "-2px",
    },
});
export class RadioButton extends React.Component {
    constructor(props) {
        super(props);
    }
    handleSelect(event) {
        this.props.onChange && this.props.onChange(this.props.value);
    }
    render() {
        return (React.createElement("div", { className: cx(radioClass) },
            React.createElement("label", { htmlFor: this.props.id },
                React.createElement("input", { id: this.props.id, type: "radio", checked: this.props.checked, name: this.props.name, required: this.props.required, disabled: this.props.disabled, value: this.props.value, onChange: this.handleSelect }),
                this.props.label)));
    }
}
__decorate([
    bind,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], RadioButton.prototype, "handleSelect", null);
export default RadioButton;
//# sourceMappingURL=radiobutton.js.map